/* eslint-disable no-param-reassign */
import type { ActionFunctionAny, Action } from 'redux-actions'
import { createAction } from 'redux-actions'
import { toPascal, toCamel } from '../_utils/case'

import type { EasyKeys, EasySetKeys, EasyStates, EasyUpperKeys } from '../States'

function unitAction<T extends EasyStates, K extends EasyKeys>(_source: T, key: K, _value?: T[K]): ActionFunctionAny<Action<any>> {
  return createAction(key.toUpperCase())
}

export function buildActions<T extends EasyStates>(obj: T): { [key in EasySetKeys]: ActionFunctionAny<Action<any>> } {
  const arr = Object.keys(obj) as EasyKeys[]
  return arr.reduce((sum, key) => {
    const camel = toCamel(`set_${toPascal(key)}`) as EasySetKeys
    sum[camel] = unitAction<EasyStates, EasyKeys>(obj, key)
    return sum
  }, Object.create(null))
}
